import { useMultiARCs } from "providers/MultiARCsControlProvider";
import { useSelectedRobots } from "../../FleetPage";
import Subpage, { useSubpage } from "components/layout/Subpage";
import MissionSelector from "./MissionSelector";
import NavigateToSelector from "./NavigateToSelector";

const Subpages = ({ className }: React.HTMLProps<HTMLDivElement>) => {
    const { selectedRobots, robotSelection } = useSelectedRobots();
    const { arcs } = useMultiARCs();
    const { close: closeSubpage } = useSubpage();
    const onAssigned = () => {
        robotSelection.clear();
        closeSubpage();
    };
    return (
        <Subpage className={className}>
            <Subpage.Alt
                title="Assign Mission"
                id="mission_assign"
                className="h-full overflow-hidden"
            >
                <MissionSelector
                    onAssigned={onAssigned}
                    mapId={"TODO Change me"}
                    assignee={arcs[selectedRobots[0]]}
                ></MissionSelector>
            </Subpage.Alt>
            <Subpage.Alt
                title="Navigate To Point"
                id="navigate_to"
                className="h-full overflow-hidden"
            >
                <NavigateToSelector
                    onNavigationStarted={() => {
                        closeSubpage();
                    }}
                ></NavigateToSelector>
            </Subpage.Alt>
        </Subpage>
    );
};

export default Subpages;
